
    import BaseClass from '@/base'
    import { Component, Prop } from 'vue-property-decorator'

    @Component
    export default class RegisterView extends BaseClass {
        @Prop(String) readonly icon!: string
        @Prop(String) readonly message!: string
    }
